import {
  GET_CAMPAIGN_NOTES,
  GET_CAMPAIGN_NOTES_SUCCESS,
  GET_CAMPAIGN_NOTES_ERROR,
  CREATE_CAMPAIGN_NOTES,
  CREATE_CAMPAIGN_NOTES_SUCCESS,
  CREATE_CAMPAIGN_NOTES_ERROR,
  UPDATE_CAMPAIGN_NOTES,
  UPDATE_CAMPAIGN_NOTES_SUCCESS,
  UPDATE_CAMPAIGN_NOTES_ERROR,
  DELETE_CAMPAIGN_NOTES,
  DELETE_CAMPAIGN_NOTES_SUCCESS,
  DELETE_CAMPAIGN_NOTES_ERROR,
} from "./actionTypes";

/* GET CAMPAIGN NOTES */
export const getCampaignNotes = (note) => ({
  type: GET_CAMPAIGN_NOTES,
  payload: note
});

export const getCampaignNotesSuccess = (data) => ({
  type: GET_CAMPAIGN_NOTES_SUCCESS,
  payload: data,
});

export const getCampaignNotesError = (error) => ({
  type: GET_CAMPAIGN_NOTES_ERROR,
  payload: error,
});

/* CREATE CAMPAIGN NOTES */
export const createCampaignNotes = (newNotes) => ({
  type: CREATE_CAMPAIGN_NOTES,
  payload: newNotes,
});

export const createCampaignNotesSuccess = (data) => ({
  type: CREATE_CAMPAIGN_NOTES_SUCCESS,
  payload: data,
});

export const createCampaignNotesError = (error) => ({
  type: CREATE_CAMPAIGN_NOTES_ERROR,
  payload: error,
});

/* UPDATE CAMPAIGN NOTES */
export const updateCampaignNotes = (notes) => ({
  type: UPDATE_CAMPAIGN_NOTES,
  payload: notes,
});

export const updateCampaignNotesSuccess = (data) => ({
  type: UPDATE_CAMPAIGN_NOTES_SUCCESS,
  payload: data,
});

export const updateCampaignNotesError = (error) => ({
  type: UPDATE_CAMPAIGN_NOTES_ERROR,
  payload: error,
});

/* DELETE CAMPAIGN NOTES */
export const deleteCampaignNotes = (notesId) => ({
  type: DELETE_CAMPAIGN_NOTES,
  payload: notesId,
});

export const deleteCampaignNotesSuccess = (data) => ({
  type: DELETE_CAMPAIGN_NOTES_SUCCESS,
  payload: data,
});

export const deleteCampaignNotesError = (error) => ({
  type: DELETE_CAMPAIGN_NOTES_ERROR,
  payload: error,
});
